<template>
    <div>
      <v-simple-table>
      <template >
        <thead>
          <tr>
            <th class="text-left">
               Importer/Distributor in the UK
              <span class="red--text">*</span>
            </th>
             <th>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(object, index) in distributorObject" :key="index">
            <td style="width: 95%;">
              <v-text-field solo v-model="object.description" placeholder="Enter Importer/Distributor in the UK"  hide-details class="py-2"/>
            </td>
            <td class="pa-0">
               <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                     <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      v-show="index + 1 === distributorObject.length"
                      small
                      @click="addDistributor"
                      >
                      <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                  </template>
                  <span>Add</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn icon class="mr-2" @click="removeLine(index)" small v-bind="attrs"
                      v-on="on">
                        <v-icon color="red">mdi-trash-can-outline</v-icon>
                      </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
      </v-simple-table>
    </div>
  </template>
  
  <script>
  export default {
    name: "Distributor",
    data() {
      return {
        blockRemoval: true,
      };
    },
    props: {
      distributorObject: Array,
    },
    watch: {
      distributorObject() {
        this.blockRemoval = this.distributorObject.length <= 1;
      },
    },
    methods: {
      addDistributor() {
        // let checkEmptyLines = this.distributorObject.filter(
        //   (line) => line.description === null
        // );
        // if (checkEmptyLines.length >= 1 && this.distributorObject.length > 0) {
        //   return;
        // }
        this.distributorObject.push({
          description: null,
        });
        this.$emit("giveDistributorToParent", this.distributorObject);
      },
      removeLine(objId) {
        if (!this.blockRemoval) {
          this.distributorObject.splice(objId, 1);
        }
      },
    },
    mounted() {
      this.addDistributor();
    },
  };
  </script>